import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { JobTitle, Department } from "models/org-chart-node";
import Employee from "models/employee";
import User from "models/user";
import Role from "models/role";

export interface ProfileSliceState {
  user: User | null,
  jobTitle: JobTitle | null
  department: Department | null
  employee: Employee | null
  roles: Role[]
}

export const initialState: ProfileSliceState = {
  user: null,
  jobTitle: null,
  department: null,
  employee: null,
  roles: []
};

const ProfileSlice = createSlice({
  name: "Profile",
  initialState,
  reducers: {
    setUser(state: ProfileSliceState, { payload }: PayloadAction<User | null>) {
      state.user = payload
    },
    setOrgContext(state: ProfileSliceState, { payload }: PayloadAction<{
      jobTitle: JobTitle | null
      department: Department | null
      employee: Employee | null
      roles: Role[]
    }>) {
      state.jobTitle = payload.jobTitle;
      state.department = payload.department;
      state.employee = payload.employee;
      state.roles = payload.roles
    },
    setEmployeeWillingToRelocate(state: ProfileSliceState, { payload }: PayloadAction<boolean>) {
      if (state.employee) {
        state.employee.willingToRelocate = payload as any
      }
    }
  },
});

export const {
  setOrgContext,
  setUser,
  setEmployeeWillingToRelocate
} = ProfileSlice.actions

export default ProfileSlice.reducer;